import {
  DASHBOARD_ELEMENT_ALL,
  DASHBOARD_ELEMENT_GET,
  DASHBOARD_ELEMENT_PUT,
  DASHBOARD_ELEMENT_DELETE,
  DASHBOARD_ELEMENT_POST,
  DASHBOARD_ELEMENT_LOADING,
  DASHBOARD_ELEMENT_ERROR,
} from '../../actions/types';

const initialState = {
  dashboardElement: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function DashboardElementReducer(state = initialState, action) {
  switch (action.type) {
    case DASHBOARD_ELEMENT_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case DASHBOARD_ELEMENT_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case DASHBOARD_ELEMENT_POST:
      return { isLoading: false, isCompleted: true };
    case DASHBOARD_ELEMENT_PUT:
      return { isLoading: false, isCompleted: true };
    case DASHBOARD_ELEMENT_DELETE:
      return { isLoading: false, isCompleted: true };
    case DASHBOARD_ELEMENT_LOADING:
      return { isLoading: true, isCompleted: true };
    case DASHBOARD_ELEMENT_ERROR:
      return { isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
